import { render } from "./JFrecall.vue?vue&type=template&id=bcf10f2e&scoped=true"
import script from "./JFrecall.vue?vue&type=script&lang=js"
export * from "./JFrecall.vue?vue&type=script&lang=js"

import "./JFrecall.vue?vue&type=style&index=0&id=bcf10f2e&lang=scss&scoped=true"
import "./JFrecall.vue?vue&type=style&index=1&id=bcf10f2e&lang=css"

import exportComponent from "D:\\workCode\\PC\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcf10f2e"]])

export default __exports__